import * as _ from 'underscore';

declare var window: any;

export const config = {
    API_ENDPOINT: './',
    SSE_ENDPOINT: '/sse',

    CSP_NONCE: '',

    TEMPLATES_ROOT_DIR_ID: 2,
    TEMPLATES_ROOT_DIR_NAME: 'Widgets Collection',

    WIDGETS_ROOT_DIR_ID: 1,
    WIDGETS_ROOT_DIR_NAME: 'WS Root',

    UNSAVED_WORKSPACE_CHANGES_TITLE: "Current workspace isn't in sync with server",
    UNSAVED_WORKSPACE_CHANGES_MESSAGE:
        "Workspace changes are saved locally. They won't be lost when you leave the page. However, you may want to save changes to server by clicking 'Save changes'.",
    UNSAVED_WORKSPACE_CHANGES_MESSAGE_UNLOAD:
        "Workspace changes are saved locally. They won't be lost when you leave the page. However, you may want to save changes to server before you leave.",
    UNSAVED_WORKSPACE_CHANGES_WILL_BE_LOST_TITLE: 'Changes will be lost',
    UNSAVED_WORKSPACE_CHANGES_WILL_BE_LOST_MESSAGE:
        'The workspace contains unsaved changes that will be lost unless saved before closing.',

    ROUTER_ROOT: '/',
    TITLE_PREFIX: 'PDC Dashboard',
    CONTACT_VENDOR: 'contact PDC',
    CONTACT_VENDOR_URL: 'https://www.pdc.com/contact/',
    PRIVACY_POLICY_URL: 'https://www.pdc.com/privacy-policy/privacy-policy-for-pdc-customer-portal/',
    LOGO_APP_TITLE: 'PDC Dashboard',
    LOGO_IMAGE_URL: './assets/PDC Logo.png',
    LOGO_IMAGE_WIDTH: '100%',
    LOGO_IMAGE_HEIGHT: '',
    LOGIN_FORM_HEIGHT: '550px',
    LOGIN_FORM_WIDTH: '450px',
    LOGIN_FORM_TOP: '10%',
    LOGIN_FORM_RIGHT: '',
    LOGIN_FORM_LEFT: '',
    LOGIN_FORM_BACKGROUND_IMAGE_URL: '',
    LOGIN_FORM_BACKGROUND_IMAGE_POSITION: '0px 0px 0px 0px',

    ENV: 'dev',

    AUTH_COOKIE_DEFAULT_EXPIRES: 7776000,
    AUTH_COOKIE_NAME: 'userToken',
    AUTH_COOKIE_PATH: null,
    AUTH_TOKEN_OVERRIDE: null,

    USERS_ADMIN_CAN_ENTER_PW: true,
    USERS_EMAIL_AS_LOGIN: true,
    USERS_PW_CAN_BE_RESENT: false,
    USERS_PW_MIN_LENGTH: 8,
    USERS_PW_MUST_HAVE_MIXED_LETTER_CASE: false,
    USERS_PW_MUST_HAVE_NUMBERS_AND_LETTERS: false,
    USERS_DEFAULT_GROUPS_VALUE: [1],
    GOOGLE_FONTS_API_KEY: 'AIzaSyCxy0V0m20kkrCnVfPYphABqHjrRXqXfH0', //'AIzaSyALGc85HFyRbnnoDt6aBzbELhfUjuXMOp8'

    WORKSPACE_AUTO_UPDATE_DEFAULT_INTERVAL: null,

    PRINT_MODE: false,

    //APP_MODE_ENABLED: false,
    APP_MODE: false,

    INITIAL_APP_SETTINGS: null,

    DEFAULT_WIDGET_TYPE_GROUP: 'Charting',

    ASSETS_PATH_ROOT: '/',

    PUBLIC_PATH: '/jscomponents/_dist/',

    SAVE_WIDGET_CONFIG_DEFAULTS: false,

    SUPPORTED_LOCALES: 'en, dk, ru',

    LAYOUT_TYPE: 'normal',
    SINGLE_WORKSPACE: null,

    URL_MAX_LENGTH: 16384,
    HTTP_REQUEST_HEADER_BUFFER_SIZE: 2048,

    themeID: 'workspace',

    widgetTypes: {
        workspace: 'pdc-widget-workspace',
        tabbedWidget: 'pdc-widget-multiple',
        nestedLayout: 'pdc-widget-layout',
        html: 'pdc-widget-html',
        drillDown: 'pdc-widget-drill-down',
        attributeFilter: 'pdc-widget-filter-attributes',
        periodFilter: 'pdc-widget-filter-period',
        cards: 'pdc-widget-cards2'
    },

    getAPIEndpoint: () => {
        let result = config.API_ENDPOINT.replace(/(\/)+$/g, '');

        if (result.endsWith('/')) {
            result = result.slice(0, result.length - 1);
        }

        return result;
    }
};

if (window.pdc != null && window.pdc.platform != null && window.pdc.platform.config != null) {
    _.extend(config, window.pdc.platform.config);
    _.defaults(window.pdc.platform.config, config);
}
